import type { BookingTaskAllocation } from '@shared/modules/bookings/models/booking-task-allocation';
import { Presenter } from '@shared/presenters/presenter';
import { ClientTaskCompletionPresenter } from '../client-task-completions/client-task-completion.presenter';
import { ClientTaskScheduleEntryPresenter } from '../client-task-schedule-entries/client-task-schedule-entry.presenter';

export class BookingTaskAllocationPresenter extends Presenter<BookingTaskAllocation> {
    get task(): ClientTaskScheduleEntryPresenter {
        return this.present('client_task_schedule_entry.data', ClientTaskScheduleEntryPresenter);
    }

    get completion(): ClientTaskCompletionPresenter {
        return this.present('completion.data', ClientTaskCompletionPresenter);
    }

    get icon() {
        return this._get('icon', () => {
           if (this.data.is_completed) {
               return 'check_circle';
           }

           if (this.task.data.type === 'medication') {

           }
        });
    }
}
